module.exports = __webpack_public_path__ + "img/horizontal_4_4_pp1_8019.edc2e657.png";